// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__38bNK","notes":"Notes_notes__3H0PV"};